import PropTypes from 'prop-types';
import React from 'react';
import {
  ToggleContainer,
  ToggleSwitch,
  ToggleInput,
  ToggleSlider,
  ToggleLabel,
} from './StyledComponents';

/**
 * Toggle - A reusable toggle switch component
 *
 * @param {boolean} checked - Whether the toggle is checked
 * @param {Function} onChange - Callback when toggle changes
 * @param {string} label - Optional label text
 * @param {string} checkedLabel - Label text when checked
 * @param {string} uncheckedLabel - Label text when unchecked
 * @param {boolean} disabled - Whether the toggle is disabled
 */
const Toggle = ({
  checked,
  onChange,
  label,
  checkedLabel,
  uncheckedLabel,
  disabled = false,
  ...props
}) => {
  // Determine what label to show
  const displayLabel = label || (checked ? checkedLabel : uncheckedLabel);

  return (
    <ToggleContainer>
      <ToggleSwitch>
        <ToggleInput
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          {...props}
        />
        <ToggleSlider />
      </ToggleSwitch>
      {displayLabel && <ToggleLabel>{displayLabel}</ToggleLabel>}
    </ToggleContainer>
  );
};

Toggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  checkedLabel: PropTypes.string,
  uncheckedLabel: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Toggle;
